import React from "react";
import { Button } from "@murm/ant";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { formatTitle } from "../../../lib/formatText";
import styles from "../DataCatalog.module.css";
import { PENDO_ID, pendoId } from "../../../lib/pendoIds";

/** "← Back to Categories" (Explorer Figma, 2c mid-level categories). */
export const BackButton = ({ onClick, backTarget }) => (
  <Button
    {...pendoId(PENDO_ID.CATALOG_BACK)}
    className={styles.backButton}
    onClick={onClick}
    icon={<ArrowLeftOutlined />}
  >
    Back to {formatTitle(backTarget)}
  </Button>
);
